import React from "react";
import OfficeForm from "./OfficeForm";

export default function AddOffice() {
  return <OfficeForm type="Add" />;
}
